// Imports
import Axios from '@/config/AxiosConfig';
import {getModPermissionsData} from "./UserServices";
import {useContactModStore} from "../stores/contactModStore";

// Get Contact Board
export const getContactsList = async (id,sort,qureyString='') => {
    const url = sort ? `/contact/list/${id}/${sort}${qureyString}` : `/contact/list/${id}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};
// Get Contact Board Data
export const getContactBoardData = async (boardId) => {
    const url = `/contact/board/data/${boardId}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};
// Get Contact Board mapping for web registration Data
export const getContactBoardMappingData = async () => {
    const url = `/contact/board/get-board-contact-list`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};
// Get Contact Board mapping for web registration Data
export const saveContactMappingData = async (payload) => {
    const url = `/contact/board/add-board-contact`;

    try {
        const { data } = await Axios.post(url,payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Get Contact
export const getContacts = async (contactType) => {
    const url = `/contact/get-contact/${contactType}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};
// Get Contact Attachments View
export const getContactAttachment = async (name) => {
    const url = `/property/download`;
    const payload ={
        file:name,
        mod:'contacts'
    }
    try {
        const { data } = await Axios.post(url,payload);
        return data;
    } catch (e) {
        return e.response;
    }
};


// Get Contact Form Fields
export const getContactFormFields = async (id) => {
    const url = `/contact/field-list/${id}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};


// Get Contact Filters
export const getContactFilters = async (id) => {
    const url = `/contact/get-filters/${id}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Update Contact Filters
export const updateContactFilters = async (payload) => {
    const url = `/contact/update-filter`;

    try {
        const { data } = await Axios.post(url,payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Add Contact
export const addContact = async (payload) => {
    const url = '/contact/add';

    try {
        // const { data } = await Axios.post(url, payload);
        const { data } = await Axios.post(url, payload, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return data;
    } catch (e) {
        return e.response;
    }
};

// update Contact
export const updateContact = async (payload) => {
    const url = '/contact/update';

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Get Contact Form Fields
export const getContactTypeLabels = async (contactType) => {
    const url = `/contact/label/get/${contactType}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Update Contact Board Step
export const updateContactBoardStep = async (groupId, stepId) => {
    const url = `contact/change-group-step/${groupId}/${stepId}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Update Contact Group Labels
export const updateContactLabels = async (payload) => {
    const url = `contact/change-group-labels`;

    try {
        const { data } = await Axios.post(url,payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Get Contact Group
export const getContactGroup = async (contactType, id) => {
    const url = `/contact/get/${contactType}/${id}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Get Contact Group
export const getSupplierType = async (qurey) => {
    const url = `/contact/get-supplier-types/${qurey}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};






// Get Contact Attachments Both Custom and System
export const getContactFiles = async (contactType, id) => {
    const url = `/contact/get-contact-modal/${contactType}/${id}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};
// Get Contact Attachments Link Both Custom and System
export const getContactLink = async (attachName, type) => {
    const url = `/contact/get_attachment/${attachName}/${type}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Sort Contact Group
export const sortContactGroup = async (payload) => {
    const url = "contact/sort-group";

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Delete Contact Group
export const deleteContactGroup = async (id,status) => {
    const url = `/contact/delete-group/${id}/${status}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Bulk Delete Contact Group
export const bulkDeleteContactGroup = async (id, payload) => {
    const url = `/contact/bulk/delete/${id}`;

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Archive Contact Group
export const archiveContactGroup = async (id,status) => {
    const url = `/contact/change-group-status/${id}/${status}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};


// Bulk Assign Label Contact Group
export const bulkAssignLabelContactGroup = async (id, payload) => {
    const url = `/contact/bulk/reassign-label/${id}`;

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Get Contacts logs
export const getContactGroupLogs = async (groupId,tabName = '') => {
    const url = `timeline/get-timelines?contact_group_id=${groupId}` + (tabName ?`&tab=${tabName}` : '');
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};


// Bulk Archive Contact Group
export const bulkArchiveContactGroup = async (id, payload) => {
    const url = `/contact/bulk/archive/${id}`;

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Bulk Re-assign Contact Group
export const bulkReassignContactGroup = async (id, payload) => {
    const url = `/contact/bulk/reassign-user/${id}`;

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const updateContactTypeLabels = async (payload) => {
    const url = `/contact/label/update`;
    try {
        const { data } = await Axios.post(url,payload);
        return data;
    } catch (e) {
        return e.response;
    }
};
export const updateContactModData = async () =>{
const contactModStore = useContactModStore();

    try {
        const response =  await getModPermissionsData('contacts');
        if (response && response.code === 200) {
            const contactMod = {
                users: response.data.users,
                name:'contacts',
                branches: response.data.branches,
            };
            contactModStore.setContactMod(contactMod);
        }
    } catch (e) {
        console.log(e);
    }
};
// Get property groups against buyer
export const getContactPropertyGroups = async (id) => {
    const url = `/property/groups/${id}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Add Contact
export const addSearchCriteria = async (payload) => {
    const url = '/contact/alert/create';

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};
// Update Contact
export const updateSearchCriteria = async (payload) => {
    const url = '/contact/alert/update';

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};
// get Contact criterias
export const getSearchCriterias = async (groupId) => {
    const url = `/contact/alert/get/${groupId}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// get display criteria canvas
export const displayCriteria = async (payload) => {
    const url = `/contact/alert/display_criteria`;

    try {
        const { data } = await Axios.post(url,payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// get display criteria canvas
export const dynamicCriteria = async (payload) => {
    const url = `/contact/alert/dynamic_criteria`;

    try {
        const { data } = await Axios.post(url,payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// get save_criteria canvas
export const saveCriteria = async (payload) => {
    const url = `/contact/alert/save_criteria`;

    try {
        const { data } = await Axios.post(url,payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// get save_criteria canvas
export const getCriteriaList = async (payload) => {
    const url = `/contact/alert/get_critera`;

    try {
        const { data } = await Axios.post(url,payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// get save_criteria canvas
export const editCriteria = async (id) => {
    const url = `/contact/alert/show_edit/${id}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// get save_criteria canvas
export const updateCriteria = async (payload) => {
    const url = `/contact/alert/update_critera`;

    try {
        const { data } = await Axios.post(url,payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// get save_criteria canvas
export const dynamicChartData = async (payload) => {
    const url = `/contact/alert/dynamic_chart_data`;

    try {
        const { data } = await Axios.post(url,payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// get save_criteria canvas
export const deleteCriteria = async (payload) => {
    const url = `/contact/alert/delete`;

    try {
        const { data } = await Axios.post(url,payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// get Contact Buying
export const getBuyingProperties = async (groupId) => {
    const url = `sale/get-property-sales/b/${groupId}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};
// get Contact criterias
export const changeSearchCriteriaStatus = async (id,status) => {
    const url = `/contact/alert/change-status/${id}/${status}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// delete search critearea
// http://api.voza-local.io/api/v1/contact/alert/delete/1
export const deleteSearchCriteria = async (id) => {
    const url = `/contact/alert/delete/${id}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};



// get Contact criterias
export const getSearchCriteriaById = async (id) => {
    const url = `/contact/alert/get-by-id/${id}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const Getproperties = async (payload) => {
    const url = `/contact/get-properties-by-group/${payload}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};
export const GetPropertyAlert = async (payload) => {
    const url = `/contact/alert/get/${payload}`;
    try {
        const { data } = await Axios.get(url, payload);
        return data.data;
    } catch (e) {
        return e.response;
    }
};
export const GetMatchingProperties = async (payload) => {
    const url = `/contact/alert/get-matching-properties/${payload.group_id}?alert_id=${payload.alert_id}&page_no=${payload.page_no}&pf_branches=${payload.pf_branches || ''}&pf_labels=${payload.pf_labels || ''}&pf_users=${payload.pf_users || ''}&sales_status=${payload.sales_status || ''}&active=${payload.active || ''}&sort_by=${payload.sort_by || ''}
    `;
    try {
        const { data } = await Axios.get(url, payload);
        return data
    } catch (e) {
        return e.response;
    }
};


export const GetMatchingViewing = async (payload) => {
    const url = `/contact/alert/get-matching-viewings/${payload.group_id}?alert_id=${payload.alert_id}&page_no=${payload.page_no}`;
    try {
        const { data } = await Axios.get(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};


export const UpdateFilter = async (payload)=>{
    const url = '/contact/alert/update-filter'
    try{
         const data = await Axios.post(url,payload)
    }catch(e){
       return e.response
    }
}

export const GetFilter = async (payload)=>{
    const url = `/contact/alert/get-filters/${payload.alert_id}`
    try{
         const {data} = await Axios.get(url,payload)
         return data
    }catch{
        return e.response;
    }
}


export const GetChartData = async (payload, property_type)=>{
    const url = `/contact/alert/get-property-filter-price?branch_id=${payload}&property_type=${property_type}`
    try{
         const {data} = await Axios.get(url)
         return data
    }catch{
        return e.response;
    }
}




export const searchSupplierType = async (query, cachedOption)=>{
    console.log(query ,'searchSupplierType')
    if (cachedOption) return cachedOption
    try{
       const {data, code} = await getSupplierType(query.search)
       if(code == 200){
        return data.map((result) => {
      return {
        label: result.name,
        value: result.id,
      }
       })
    }
    }catch(e){
        console.log(e)
    }
 }